import { publishDomain } from './PublishStore';

export const updatePublishDomain = (value) => publishDomain.update((oldValue) => value);
